import { render, staticRenderFns } from "./TooltipAvatar.vue?vue&type=template&id=5c1e9134&"
import script from "./TooltipAvatar.vue?vue&type=script&lang=js&"
export * from "./TooltipAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports